// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"U2-z","displaySixCardTiles":"V2-z"};